module.exports = __webpack_public_path__ + "p.no2.6c6e0545.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/p.no2.jpg
// module id = OvM5
// module chunks = 0